export const getRatePlansByRoom = (ratePlansResponse) => {
  const ratePlansByRoom = {};
  ratePlansResponse.data.forEach((ratePlan) => {
    ratePlan.room.forEach((roomId) => {
      if (!ratePlansByRoom[roomId]) {
        ratePlansByRoom[roomId] = [];
      }
      ratePlansByRoom[roomId].push(ratePlan);
    });
  });
  return ratePlansByRoom;
};
